import SlideOutButton from "../common/SlideOutButton";
import useDevLockStagedOrder from "./useDevLockStagedOrder";

interface LockStagedOrderButtonProps {
  stagedOrderId: string;
}

const LockStagedOrderButton = ({ stagedOrderId }: LockStagedOrderButtonProps) => {
  const lockRequest = useDevLockStagedOrder(stagedOrderId);

  return <SlideOutButton text="Lock Staged Order" onClick={() => lockRequest.request()} />;
}

export default LockStagedOrderButton;
